(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fv-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function focusStatus() {
      var el = document.querySelector('[data-fv-contact] [data-fv-cf-status]');
      if (el && typeof el.focus === 'function') {
        try { el.focus({ preventScroll: false }); } catch (e) { el.focus(); }
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', focusStatus);
    } else {
      focusStatus();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.FvFaqEditor) return;
    window.FvFaqEditor = true;
    document.addEventListener('shopify:block:select', function (event) {
      var target = event.target;
      if (target instanceof Element && target.matches('details.fv-faq__item')) target.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(min-width: 750px)');

    function sync() {
      var cols = document.querySelectorAll('[data-fv-ft-col]');
      Array.prototype.forEach.call(cols, function (col) {
        var summary = col.querySelector('summary');
        if (mq.matches) {
          col.open = true;
          if (summary) summary.setAttribute('tabindex', '-1');
        } else {
          if (!col.dataset.fvTouched) col.open = false;
          if (summary) summary.removeAttribute('tabindex');
        }
      });
    }

    function bind() {
      var cols = document.querySelectorAll('[data-fv-ft-col]');
      Array.prototype.forEach.call(cols, function (col) {
        if (col.dataset.fvBound) return;
        col.dataset.fvBound = 'true';
        var summary = col.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', function (e) {
          if (mq.matches) { e.preventDefault(); return; }
          col.dataset.fvTouched = 'true';
        });
      });
      sync();
      // Only move focus when this footer form was the one submitted
      // (Shopify returns to the page with #<form id> in the URL).
      var status = document.querySelector('[data-fv-footer] [data-fv-nl-status]');
      var form = status ? status.closest('form') : null;
      if (status && form && form.id && window.location.hash === '#' + form.id && typeof status.focus === 'function') {
        try { status.focus({ preventScroll: false }); } catch (err) { status.focus(); }
      }
    }

    if (mq.addEventListener) { mq.addEventListener('change', sync); } else if (mq.addListener) { mq.addListener(sync); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bind); } else { bind(); }
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-legal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slug(text, i) {
      var s = (text || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      return s || 'section-' + (i + 1);
    }

    function init(root) {
      if (!root || root.dataset.fvLegalReady) return;
      root.dataset.fvLegalReady = 'true';
      var body = root.querySelector('[data-fv-legal-body]');
      if (!body) return;
      var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));

      heads.forEach(function (h, i) {
        if (h.id) return;
        var base = slug(h.textContent, i);
        var id = base;
        var n = 2;
        while (document.getElementById(id)) { id = base + '-' + n; n += 1; }
        h.id = id;
      });

      var lists = root.querySelectorAll('[data-fv-toc-list]');
      Array.prototype.forEach.call(lists, function (list) {
        if (list.querySelectorAll('a').length === heads.length) return;
        list.textContent = '';
        heads.forEach(function (h) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.className = 'fv-legal__toc-link';
          a.setAttribute('data-fv-toc-link', '');
          a.href = '#' + h.id;
          a.textContent = (h.textContent || '').trim();
          li.appendChild(a);
          list.appendChild(li);
        });
      });

      if (heads.length) root.classList.remove('fv-legal--no-toc');

      var mobile = root.querySelector('.fv-legal__toc-m');
      if (mobile) {
        mobile.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('a')) mobile.open = false;
        });
      }

      var links = Array.prototype.slice.call(root.querySelectorAll('.fv-legal__toc [data-fv-toc-link]'));
      if (!links.length || !('IntersectionObserver' in window)) return;

      function update() {
        var line = window.innerHeight * 0.3;
        var current = heads[0];
        heads.forEach(function (h) {
          if (h.getBoundingClientRect().top <= line) current = h;
        });
        links.forEach(function (a) {
          var on = current && a.getAttribute('href') === '#' + current.id;
          a.classList.toggle('is-active', !!on);
          if (on) { a.setAttribute('aria-current', 'location'); } else { a.removeAttribute('aria-current'); }
        });
      }

      var io = new IntersectionObserver(update, { rootMargin: '0px 0px -60% 0px', threshold: [0, 1] });
      heads.forEach(function (h) { io.observe(h); });
      update();
    }

    function run() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-fv-legal]'), init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('fv-rail')) return;

    class FvRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-fv-track]');
        this.nav = this.querySelector('[data-fv-rail-nav]');
        if (!this.track || !this.nav) return;
        this.prev = this.nav.querySelector('[data-dir="-1"]');
        this.next = this.nav.querySelector('[data-dir="1"]');
        this.update = this.update.bind(this);
        this.onClick = this.onClick.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.nav.addEventListener('click', this.onClick);
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.update);
          this.ro.observe(this.track);
        }
        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.update);
        if (this.nav) this.nav.removeEventListener('click', this.onClick);
        if (this.ro) this.ro.disconnect();
      }

      update() {
        var t = this.track;
        var max = t.scrollWidth - t.clientWidth;
        var x = Math.abs(t.scrollLeft);
        this.nav.hidden = max <= 4;
        if (this.prev) this.prev.disabled = x <= 4;
        if (this.next) this.next.disabled = x >= max - 4;
      }

      onClick(event) {
        var button = event.target instanceof Element ? event.target.closest('[data-dir]') : null;
        if (!button) return;
        var dir = Number(button.getAttribute('data-dir')) || 1;
        var rtl = getComputedStyle(this.track).direction === 'rtl';
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: this.track.clientWidth * 0.9 * dir * (rtl ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
      }
    }

    customElements.define('fv-rail', FvRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
